/// <reference types="@angular/localize" />

// Angular modules
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

// External modules
import { appConfig } from './app/app.config';

// Internal modules
import { environment } from './environments/environment';

// Components
import { AppComponent } from './app/app.component';
import localeVi from '@angular/common/locales/vi';
import { registerLocaleData } from '@angular/common';

if (environment.production) {
  enableProdMode();
}
registerLocaleData(localeVi); // load vi locale once at startup

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
